import { SOCKET_ADD_USER, SOCKET_SET_USERS } from '../../actions/types';

const initialState = {
  users: []
};

export default function socketReducer(state = initialState, action) {
  switch (action.type) {
    case SOCKET_SET_USERS:
      return {
        ...state,
        users: [...new Set(action.payload)]
      };
    case SOCKET_ADD_USER:
      return {
        ...state,
        users: [...new Set([...state.users, action.payload])]
      };
    default:
      return state;
  }
}
